import { connect } from 'react-redux';
import React, { useEffect } from 'react';
import Modal from '../../../layout/modal/Modal';
import styles from './AddDocumentModal.module.scss';
import { getExtraForms } from '../../../../redux/deals/action';
import { closeModal, openModal } from '../../../../redux/modals/action';
import { useHistory } from 'react-router';
import { setAlert } from '../../../../redux/alerts/action';

const AddDocumentModal = ({
	showModal,
	handleCloseAddDocument,
	getExtraForms,
	extraForms,
	openModal,
	setFormInfo,
	leadId,
	closeModal,
	latestAPSStatus,
	documentStatus,
	setAlert,
}) => {
	const history = useHistory();

	useEffect(() => {
		getExtraForms();
		console.log('extraForms', extraForms);
	}, []);

	const handleSelectForm = (formInfo) => {
		if (
			latestAPSStatus === 'signature_request_canceled' &&
			documentStatus === 'cancelled'
		) {
			setAlert('warning', 'APS document needs to be created first.');
		} else {
			openModal('docFormField');
			console.log('handleSelectForm formInfo', formInfo);
			setFormInfo(formInfo);
		}
	};

	const handleAPS = () => {
		if (latestAPSStatus === 'signature_request_sent') {
			setAlert(
				'warning',
				'Please cancel existing APS document before you create new APS document.'
			);
		} else {
			history.push({
				pathname: `/agreement/${leadId}`,
				state: {
					from: 'Purchasers',
				},
			});
			closeModal('addDocument');
		}
	};

	return (
		<div className={styles.addDocumentModal}>
			{showModal === true && (
				<Modal show={showModal} close={handleCloseAddDocument}>
					<div className={styles.title}>Add Document</div>
					<div className={styles.extra_form_wrapper}>
						<div
							className={styles.form_item}
							onClick={() => handleAPS()}
						>
							APS
						</div>
						{extraForms.map((form, index) => {
							return (
								<div
									className={styles.form_item}
									key={index}
									onClick={() => handleSelectForm(form)}
								>
									{form.name}
								</div>
							);
						})}
					</div>
				</Modal>
			)}
		</div>
	);
};

const mapStateToProps = (state) => ({
	extraForms: state.leads.extraForms,
	leadId: state.purchasers?.purchaserById?.leadId,
	documentStatus:
		state.agreement.agreementById?.documentInformation?.documentStatus,
});

export default connect(mapStateToProps, {
	getExtraForms,
	openModal,
	closeModal,
	setAlert,
})(AddDocumentModal);
